import React from 'react';
import styles from './_style.module.scss';

const QuoteBuilderLayout = ({ drawing, children }) => {
  return (
    <div className={styles.layoutContainer} data-widget-element="layout-container">
      <div className={styles.imageColumn} data-widget-element="image-column">
        {drawing.image !== undefined && (
          <img
            src={drawing.image.three_d_image_url}
            className={styles.previewImage}
            data-widget-element="preview-image"
            alt="3D Preview"
          />
        )}
      </div>
      <div className={styles.formColumn} data-widget-element="form-column">
        <div className={styles.header} data-widget-element="header">
          <h3 className={styles.title} data-widget-element="title">{t('quote_builder_widget.get_a_quote')}</h3>
        </div>
        <div className={styles.formSection} data-widget-element="form-section">
          {children}
        </div>
      </div>
    </div>
  );
};

export default QuoteBuilderLayout;
